import { Search } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FormField } from '@/components/app';
import { UserFiltersProps } from '../types';

/** Панель фильтров списка (макет «Пользователи»). Только фильтры, которые поддерживает GET /users. */
export function UserFilters({
  searchQuery,
  roleFilter,
  subscriptionFilter,
  deletionFilter,
  onSearch,
  onRoleFilter,
  onSubscriptionFilter,
  onDeletionFilter,
}: UserFiltersProps) {
  return (
    <Card aria-label="Фильтры" role="region" className="grid gap-3.5 p-[18px] sm:grid-cols-2 xl:grid-cols-[minmax(0,2fr)_repeat(3,minmax(0,1fr))]">
      <FormField label="Поиск" tone="filter">
        {(p) => (
          <div className="relative">
            <Search aria-hidden className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-text-3" />
            <Input
              {...p}
              type="search"
              placeholder="Имя, email или логин"
              value={searchQuery}
              onChange={(e) => onSearch(e.target.value)}
              className="pl-9"
            />
          </div>
        )}
      </FormField>
      <FormField label="Статус" tone="filter">
        {(p) => (
          <Select value={subscriptionFilter} onValueChange={onSubscriptionFilter}>
            <SelectTrigger {...p}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Все</SelectItem>
              <SelectItem value="true">Premium</SelectItem>
              <SelectItem value="false">Free</SelectItem>
            </SelectContent>
          </Select>
        )}
      </FormField>
      <FormField label="Роль" tone="filter">
        {(p) => (
          <Select value={roleFilter} onValueChange={onRoleFilter}>
            <SelectTrigger {...p}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Все роли</SelectItem>
              <SelectItem value="user">Пользователь</SelectItem>
              <SelectItem value="admin">Админ</SelectItem>
            </SelectContent>
          </Select>
        )}
      </FormField>
      <FormField label="Удалён" tone="filter">
        {(p) => (
          <Select value={deletionFilter} onValueChange={onDeletionFilter}>
            <SelectTrigger {...p}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="false">Только активные</SelectItem>
              <SelectItem value="true">Только удалённые</SelectItem>
              <SelectItem value="all">Все аккаунты</SelectItem>
            </SelectContent>
          </Select>
        )}
      </FormField>
    </Card>
  );
}
